import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Hilfe(): ReactElement {
  return (
    <PageShell
      title="Hilfe-Center"
      intro="Antworten auf häufige Fragen und Unterstützung bei der Nutzung von Saldify."
    >
      <PageSection title="Erste Schritte">
        <p>
          Nach der Registrierung führt Sie ein kurzes Onboarding durch die Einrichtung
          Ihrer Firma. Anschließend können Sie Rechnungen schreiben, Belege erfassen,
          Ihr Bankkonto anbinden und Auswertungen abrufen.
        </p>
      </PageSection>

      <PageSection title="Häufige Themen">
        <ul className="list-disc pl-6 space-y-1">
          <li>Rechnungen erstellen und versenden</li>
          <li>Belege erfassen und automatisch erkennen lassen</li>
          <li>Bankkonto über FinTS anbinden</li>
          <li>Umsatzsteuer-Voranmeldung und EÜR vorbereiten</li>
          <li>Daten für den Steuerberater exportieren (DATEV)</li>
        </ul>
      </PageSection>

      <PageSection title="Noch Fragen?">
        <p>
          Wenn Sie hier nicht weiterkommen, hilft Ihnen unser Team gerne. Alle
          Kontaktwege finden Sie auf der{' '}
          <a href="/kontakt" className="text-primary-600 hover:underline">
            Kontaktseite
          </a>
          .
        </p>
      </PageSection>
    </PageShell>
  );
}
